import React from 'react'
import { behance,linkedin,twitter,dribble } from '../../assets/images'
import { lightBehance,lightLinkedin,lightTwitter,lightDribble } from '../../assets/images'
interface Props{
  effect:string
}
const Connect = (props:Props) => {


  const handles=[dribble,twitter,linkedin,behance]
  const lightHandles=[lightDribble,lightLinkedin,lightBehance,lightTwitter]
const links =["https://dribbble.com/Thirdeyesage","https://twitter.com/OOlaxy","https://www.linkedin.com/in/olaoluwa-agiri-b04a981b6/","https://www.behance.net/agiriolaoluwa/projects"]

const mobileLinks =["https://dribbble.com/Thirdeyesage","https://www.linkedin.com/in/olaoluwa-agiri-b04a981b6/","https://www.behance.net/agiriolaoluwa/projects","https://twitter.com/OOlaxy"]

  return (
    <section data-aos={props.effect} className='md:mt-[7.5rem] mt-[2.063rem]'>
      <div className='container md:pl-[61px] md:pr-[57px]'>

    
      <header className='text-[#A6B2EC] uppercase  text-[1.125rem] lg:text-[2.25rem] text-center bold'>connect with me</header>
      <ul className='flex  justify-between mx-auto md:w-[468px] sm:w-[40%] w-[50%] mt-[1.563rem] items-center'>

        {handles.map((handle,index)=>(
        <li key={index} className='md:block hidden'>
          <a href={links[index]} target="_blank">
<button><img src={handle} alt="social media" /></button>
</a>
        </li>))}

        {lightHandles.map((handle,index)=>(
        <li key={index} className='md:hidden'>
                    <a href={mobileLinks[index]} target="_blank">

<button><img src={handle} alt="social media" /></button>
</a>

        </li>))}
      </ul>
      </div>
    </section>
  )
}

export default Connect

// https://www.linkedin.com/in/olaoluwa-agiri-b04a981b6/
// https://dribbble.com/Thirdeyesage
// https://www.behance.net/agiriolaoluwa/projects
// https://twitter.com/OOlaxy